import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const inventoryProductSchema_ = z.object({
  id: productIdFormat.schema,
  productFamilyId: productFamilyIdFormat.schema,
  image: z.string().nullish(),
  title: z.string(),
  sku: z.string().nullish(),
  vendor: z.string().nullish(),
  tags: z.array(z.string()),
  totalQuantity: z.number(),
  totalBuildable: z.number(),
  totalAvailable: z.number(),
  totalCommitted: z.number(),
  totalReserved: z.number(),
  cost: z.number().nullish(),
  currency: z.string().nullish(),
  accountId: z.string(),
  accountName: z.string(),
  incomingShipmentCount: z.number(),
  incomingUnits: z.number(),
});

export const InventoryProductSchema: z.ZodType<InventoryProduct> =
  inventoryProductSchema_;
export interface InventoryProduct
  extends z.infer<typeof inventoryProductSchema_> {}

export const getInventoryProducts = {
  name: "getInventoryProducts" as const,
  input: z.object({
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int(),
    search: z.string().optional(),
    sortBy: createEnum([
      "title",
      "sku",
      "vendor",
      "cost",
      "totalAvailable",
      "totalQuantity",
      "totalBuildable",
      "totalCommitted",
      "totalReserved",
    ]).optional(),
    sortDirection: createEnum(["asc", "desc"]).optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({
    products: z.array(InventoryProductSchema),
    hasMultipleMerchants: z.boolean(),
  }),
};
